import { initializeAnalytics, type Environment } from "@fullscript/fs-analytics";

import { isProduction, isStaging } from "@shared/utils/fullscriptEnv/fullscriptEnv";

let initialized = false;
let storedKey: string | undefined;

const getFsAnalyticsEnvironment = (): Environment => {
  if (isProduction()) return "production";
  if (isStaging()) return "staging";

  return "dev";
};

/**
 * Initialize fs-analytics. This is idempotent - calling it multiple times is safe.
 * If a key is provided, it will be stored for future calls.
 * Subsequent calls can omit the key if it was previously stored.
 */
const initFsAnalytics = (rudderstackJsApiWriteKey?: string): boolean => {
  if (rudderstackJsApiWriteKey) {
    storedKey = rudderstackJsApiWriteKey;
  }

  if (initialized) return true;

  const key = rudderstackJsApiWriteKey ?? storedKey;

  if (!key) return false;

  initializeAnalytics(key, getFsAnalyticsEnvironment());
  initialized = true;

  return true;
};

export { initFsAnalytics };
